import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { VariedadService } from 'src/app/giz-library/variedad/service/variedad.service';

@Component({
  selector: 'app-variedad-list-qr',
  templateUrl: './variedad-list-qr.component.html',
  styleUrls: ['./variedad-list-qr.component.css']
})
export class VariedadListQrComponent implements OnInit {
  varietyObs!: Observable<any>;
  varietyList!: any[];
  myAngularxQrCode!: string | null;
  total: number = 0;

  constructor(private variedadService: VariedadService) { }

  ngOnInit(): void {
    this.fnGetAllVarieties();
  }

  fnGetAllVarieties() {

    this.varietyObs = this.variedadService.getAll();

    this.varietyObs.subscribe(
      (resp: any) => {
        this.varietyList = [];

        resp.data.map(
          (obj: any) => {
            if (obj.genotype_data) {


              this.varietyList.push(obj);
              this.total = this.total + 1;
            }
          }
        );
      }
    );
  }

}
